import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
const Container = styled.div `
    padding: 15px;
    margin-bottom: 30px;
    border-left: 3px solid ${color.quinary.hover};
    color: ${(props) => props.theme.textDark};
    background-color: ${color.quinary.base};

    p {
        &:last-child,
        &:first-child:last-child {
            margin: 0;
        }
    }
`;
const HighlightedContent = ({ children }) => (React.createElement(Container, null, children));
export default HighlightedContent;
